"use client";

import ImageOverlay from "@/components/image-overlay";

export interface BannerProps {
  bannerUrl: string;
}

export default function Banner(props: BannerProps) {

  return (
    <div className="h-1/2 relative xl:mt-20">
      <ImageOverlay
        src={props.bannerUrl}
        alt="hero"
        className="w-full h-1/2 object-cover"
      />
    </div>
  );
}
